import { theme } from '../../styles/theme';
import { buttonPrimaryV2 } from '../../styles/button';

export const resetPasswordContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

export const resetPasswordHeader = {
  fontSize: '40px',
  fontWeight: 800,
  color: theme.palette.common.darkGrey1,
  textAlign: 'center'
};

export const resetPasswordEmailSentHeader = {
  fontSize: '22px',
  fontWeight: 800,
  marginTop: '24px',
  color: theme.palette.common.darkGrey1,
  textAlign: 'center'
};

export const resetPasswordParagraph = {
  fontSize: '16px',
  textAlign: 'center',
  color: theme.palette.common.darkGrey2,
  marginTop: '24px'
};

export const resetPasswordFormStack = {
  marginTop: '24px'
};

export const resetPasswordButton = {
  ...buttonPrimaryV2,
  marginTop: '30px',
  marginBottom: '30px',
  minWidth: '248px'
};

export const resetPasswordLinkStyle = {
  color: 'inherit',
  fontWeight: 600,
  cursor: 'pointer'
};

export const resetPasswordSignInLink = {
  marginLeft: '10px',
  color: theme.palette.common.textInteractiveBrand
};
